import type { TOptionValue } from './Types';

export const createValueRecord = <T extends string | number>(
  values: T[],
  options: Map<T, string>,
) =>
  values.reduce(
    (record, val) => {
      const label = options.get(val);
      if (label !== undefined) {
        record[val] = label;
      }
      return record;
    },
    {} as Record<T, string>,
  );

export const toArray = <T extends string | number>(record: Record<T, string>): TOptionValue<T>[] =>
  (Object.entries(record) as [string, string][]).map(([key, label]) => ({
    value: (typeof Number(key) === 'number' && !isNaN(Number(key)) ? Number(key) : key) as T,
    label,
  }));
